import * as React from 'react';
import { LocalizedDateTime, DateTimeAccuracy } from '../../misc/components/LocalizedDateTime';
import { DcfRequestStatusEnum } from '../../misc/api/apiTypes';

interface ReviewItemProps {
    currentRequestStatus: DcfRequestStatusEnum;
    rejectedWithSuggestions: boolean;
    username: string;
    datetime: string;
    reason: string;
    stepApproved: boolean;
    title: string;
}

enum StatusClasses {
    Approved = "success",
    Rejected = "danger",
    Pending = "warning",
    RejectedWithSuggestions = "warning"
}

enum StatusLabels {
    Approved = "Approved",
    Rejected = "Rejected",
    Pending = "Pending",
    RejectedWithSuggestions = "Rejected With Suggestions",
}

const getBadgeClassName = (isApproved: boolean, rejectedWithSuggestions: boolean): string => {
    return getBadgeClass(isApproved ? StatusClasses.Approved : rejectedWithSuggestions ? StatusClasses.RejectedWithSuggestions : StatusClasses.Rejected)
}

const getBadgeClass = (status: StatusClasses) => {
    return "label label-" + status;
}

const isSkipped = (status: DcfRequestStatusEnum, user: string) => !user && status === DcfRequestStatusEnum.Rejected;

const getStatusBadge = (id: string, status: DcfRequestStatusEnum, rejectedWithSuggestions: boolean, approved: boolean, user: string) => {

    if (isSkipped(status, user)) {
        return null;
    }

    if (!user) {
        return <label id={`ReviewStatus${id}`} className={getBadgeClass(StatusClasses.Pending)}>{StatusLabels.Pending}</label>
    }

    return (
        user && <label id={`ReviewStatus${id}`} className={getBadgeClassName(approved, rejectedWithSuggestions)}>{approved ? StatusLabels.Approved : rejectedWithSuggestions ? StatusLabels.RejectedWithSuggestions : StatusLabels.Rejected}</label>
    );
}

export const ReviewItem = ({ currentRequestStatus, rejectedWithSuggestions, username, datetime, reason, stepApproved, title }: ReviewItemProps) => {
    const id = title.replace(/\s/g, "");

    return (<div className="row">
        <div className="col-sm-3">
            <h4>{title}</h4>
        </div>
        <div className="col-sm-9">
            {getStatusBadge(id, currentRequestStatus, rejectedWithSuggestions, stepApproved, username)}
        </div>
        <div className="col-sm-12">
            {!isSkipped(currentRequestStatus, username) && username ? <blockquote>
                <p id={`ReviewReason${id}`} style={{ overflowWrap: "break-word"}}>{reason}</p>
                <footer>{username} at <LocalizedDateTime time={datetime} accuracy={DateTimeAccuracy.Second} isTooltip={true} /></footer>
            </blockquote> : <span>N/A</span>}
        </div>
    </div>)
}
